import { render } from "./ColorPickerPopover.vue?vue&type=template&id=294e2c62&scoped=true"
import script from "./ColorPickerPopover.vue?vue&type=script&lang=js"
export * from "./ColorPickerPopover.vue?vue&type=script&lang=js"

import "./ColorPickerPopover.vue?vue&type=style&index=0&id=294e2c62&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\PC\\Documents\\RWI\\surefooted-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-294e2c62"]])

export default __exports__